import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing WorkOrder view counts.
 * Automatically increments the view count when the work order is viewed.
 *
 * @param workOrderId - The ID of the work order
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = useWorkOrderViewCount(workOrderId)
 */
export function useWorkOrderViewCount(workOrderId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.WorkOrder,
    value: workOrderId,
  })
}
